'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toJS = require('transmute/toJS');

var _toJS2 = _interopRequireDefault(_toJS);

var _immutable = require('immutable');

var _User = require('conversations-core/data/records/User');

var _User2 = _interopRequireDefault(_User);

var _MeetingsLink = require('conversations-core/data/records/MeetingsLink');

var _MeetingsLink2 = _interopRequireDefault(_MeetingsLink);

var _SmartList = require('conversations-core/data/records/SmartList');

var _SmartList2 = _interopRequireDefault(_SmartList);

var _Visitor = require('conversations-core/data/records/Visitor');

var _Visitor2 = _interopRequireDefault(_Visitor);

var _MessageFactory = require('conversations-schema/factories/MessageFactory');

var _ConversationFactory = require('conversations-schema/factories/ConversationFactory');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (key, value) {
  var isIndexed = _immutable.Iterable.isIndexed(value);
  if (key === 'messages' && !isIndexed) {
    return value.map(_MessageFactory.buildWelcomeMessage).toMap();
  } else if (key === 'users' && !isIndexed) {
    return value.map(function (user) {
      return (0, _User2.default)(user);
    }).toMap();
  } else if (key === 'meetingsLinks' && !isIndexed) {
    return value.map(function (meetingsLink) {
      return (0, _MeetingsLink2.default)(meetingsLink);
    }).toMap();
  } else if (key === 'smartLists' && !isIndexed) {
    return value.map(function (smartList) {
      return (0, _SmartList2.default)(smartList);
    }).toMap();
  } else if (key === 'conversations' && !isIndexed) {
    return value.map(function (conversation) {
      var rawConversation = conversation.toJS();

      if (!conversation.get('latestMessage')) {
        window.Raven.captureMessage('CONVERSATION_WITH_INVALID_LATEST_MESSAGE', { extra: (0, _toJS2.default)(conversation) });
      }

      return (0, _ConversationFactory.buildConversation)(rawConversation);
    }).toMap();
  } else if (key === 'visitors' && !isIndexed) {
    return value.map(function (visitorData) {
      return (0, _Visitor2.default)(visitorData);
    }).toMap();
  }
  return isIndexed ? value.toList() : value.toMap();
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/utils/fromJSReviver.js
// module id = 158
// module chunks = 0 1